import en from "./lang/en";
import es from "./lang/es";
import de from "./lang/de";

const LANGUAGES = [
    { code: "en", dictionary: en },
    { code: "es", dictionary: es },
    { code: "de", dictionary: de },
];
const DEFAULT_LANGUAGE = "en";
const SUPPORTED_LANGUAGES = LANGUAGES.map(l => l.code);

class Translator {
    constructor() {
        this.lang = this.getLanguage();
        this.dictionary = en;
        for (const l of LANGUAGES) {
            if (l.code == this.lang) {
                this.dictionary = l.dictionary;
                break;
            }
        }

        // Buttons with a tooltip
        const buttons = [
            [document.querySelector(".flute"), this.dictionary.flute],
            [document.querySelector(".saxo"), this.dictionary.saxophone],
            [document.querySelector(".trumpet"), this.dictionary.trumpet],
            [document.querySelector(".violin"), this.dictionary.violin],
            [document.querySelector(".bird"), this.dictionary.birds],
            [document.querySelector(".whale"), this.dictionary.whale],
            [document.querySelector(".scratch"), this.dictionary.scratch],
            [document.querySelector(".yo"), this.dictionary.yo],
            [document.querySelector(".seal"), this.dictionary.seal],
            [document.getElementById("gridbtn"), this.dictionary.toggle_grid],
            [document.getElementById("undobtn"), this.dictionary.undo],
            [document.getElementById("clearbtn"), this.dictionary.clear_canvas]
        ];
        buttons.forEach(button => {
            this.localizeTooltip(button[0], button[1]);
            this.localizeAriaLabel(button[0], button[1]);
        })

        // Alts and aria labels:
        const labels = [
            [document.getElementById("aboutbtn"), this.dictionary.about],
            [document.getElementById("sharebtn"), this.dictionary.share],
            [document.getElementById("atmospheres-btn"), this.dictionary.change_atmosphere],
            [document.getElementById("playbtn"), this.dictionary.toggle_play_pause]
        ];
        labels.forEach(button => {
            this.localizeAriaLabel(button[0], button[1]);
            this.localizeAlt(button[0], button[1]);
        });

        // Standard HTML elements
        this.localize(document.getElementById("gac-presents"), this.dictionary.GAC_presents);
        this.localize(document.getElementById("try-other-instrument"), this.dictionary.try_other_instrument);
        this.localize(document.querySelector(".helper-closebtn"), this.dictionary.ok);
        this.localize(document.getElementById("shared-welcome"), this.dictionary.shared_welcome);
        this.localize(document.getElementById("canvas-full"), this.dictionary.canvas_full);
        this.localize(document.getElementById("remove-items"), this.dictionary.remove_items);
        this.localize(document.getElementById("atmosphere-subtitle"), this.dictionary.atmosphere_subtitle);
        this.localize(document.getElementById("atmosphere-back-btn"), this.dictionary.back);
        this.localize(document.getElementById("change-atmosphere"), this.dictionary.change_atmosphere);
        this.localize(document.getElementById("main-title"), this.dictionary.title);
        this.localize(document.getElementById("ios-msg01"), this.dictionary.ios_message01);
        this.localize(document.getElementById("ios-msg03"), this.dictionary.ios_message03);
        this.localize(document.getElementById("turn-device"), this.dictionary.turn_device);
        this.localize(document.getElementById("about01"), this.dictionary.about01);
        this.localize(document.getElementById("about02"), this.dictionary.about02);
        this.localize(document.getElementById("magenta-link"), this.dictionary.about03);
        this.localize(document.getElementById("about03"), this.dictionary.about04);
        this.localize(document.getElementById("about04"), this.dictionary.about05);
        this.localize(document.getElementById("aboutclosebtn"), this.dictionary.ok);
        this.localize(document.getElementById("safari-desktop-message"), this.dictionary.safari_warning);
        this.localize(document.getElementById("scaleclosebtn"), this.dictionary.ok);
        this.localize(document.getElementById("dialog-continue"), this.dictionary.ok);
        this.localize(document.getElementById("dialog-back"), this.dictionary.go_back);
        this.localize(document.querySelector("#helper-sharing span"), this.dictionary.share_your_masterpiece);
        this.localize(document.querySelector("#helper-sharing .helper-closebtn"), this.dictionary.ok);
        this.localize(document.getElementById("createmyownbtn"), this.dictionary.create_my_own);
        this.localize(document.getElementById("shared-strokes-loader-label"), this.dictionary.generating_shared_strokes);
        this.localize(document.querySelector("#atmosphere-change-dialog p:first-child"), this.dictionary.atmosphere_warning_title);
        this.localize(document.querySelector("#atmosphere-change-dialog p:nth-child(2)"), this.dictionary.atmosphere_warning_text);
    }

    localize(element, text) {
        if (element) {
            element.textContent = text;
        }
    }

    localizeTooltip(element, text) {
        if (element && element.dataset) {
            if (element.dataset.tooltip) {
                element.dataset.tooltip = text;
            }
        }
    }

    localizeAriaLabel(element, text) {
        if (element) {
            if (element.ariaLabel) {
                element.ariaLabel = text;
            }
        }
    }

    localizeAlt(element, text) {
        if (element) {
            element.alt = text;
        }
    }

    getLanguage() {
        const urlParams = new URLSearchParams(window.location.search);
        let lang = urlParams.get("lang");
        if (!lang || !SUPPORTED_LANGUAGES.includes(lang)) {
            lang = DEFAULT_LANGUAGE;
        }
        return lang;
    }
}

export default Translator;